import React, {useEffect} from 'react'
import moment from 'moment';

import { useDispatch, useSelector } from 'react-redux';

// Services

import { clearRegistroClientesStore, clearConsultarClientesMisStore } from '../../../../../store/clients/clients.actions';

// Hooks

import CheckIfTimeIsWithinWorkHours from '../../../../../hooks/CheckIfTimeIsWithinWorkHours';

// Components

import SectionHeading from '../../../../UI/SectionHeading/SectionHeading';
import Button from '../../../../UI/Button/Button';

// Constants

import { CIVIL_STATUS } from '../../../../../config/constants';

export default function FormConfirmation({formik, formStep, setFormStep}) {
    const { checkWorkHoursIsLoading, inWorkHours, handleCheckIfTimeIsWithinWorkHours } = CheckIfTimeIsWithinWorkHours();
    // Dropdown Options
    const dropDownOptions = useSelector((state) => state.options.dropDownOptions);

    const dispatch = useDispatch();

    const getLocalityName = (localitiesData, localityId) => {
        const code = localityId;
        const item = localitiesData?.find((item) => item.value === code);
        
        return item?.name;
    }

    const getNationalityName = (localitiesData, nationalityId) => {
        const code = nationalityId;
        const item = localitiesData?.find((item) => item.value === code);
        
        return item?.nationality;
    }

    // Cleart he consult client mis and register client store before sending the form

    useEffect(() => {
        dispatch(clearConsultarClientesMisStore());
        dispatch(clearRegistroClientesStore());
    }, []);


    // Send form if within work hours

    useEffect(() => {
        if (inWorkHours === true) {
            formik.handleSubmit();
        }
    }, [inWorkHours]);

    return (
    <>
        <SectionHeading text={'Por favor confirme sus datos'} hideRequiredFieldsMessage />

        <div className='form-confirmation'>

            <div className='form-confirmation-block'>

                <h3 className="multiple-input-heading">Datos Personales</h3>

                <p className='form-confirmation-entry'>
                    <strong>Documento de Identidad:</strong> <span>{formik?.values?.cliente?.tipoDocumento !== 'P' ? formik?.values?.cliente?.tipoDocumento + formik?.values?.cliente?.cedulaRif : formik?.values?.cliente?.tipoDocumento + formik?.values?.cliente?.pasaporte}</span>
                </p>

                <p className='form-confirmation-entry'><strong>Nombres:</strong> <span>{formik?.values?.cliente?.nombre}</span></p>

                <p className='form-confirmation-entry'><strong>Apellidos:</strong> <span>{formik?.values?.cliente?.primerApellido + ' ' + formik?.values?.cliente?.segundoApellido}</span></p>

                <p className='form-confirmation-entry'><strong>Fecha de Nacimiento:</strong> <span>{moment(formik?.values?.cliente?.fechaNacimiento)?.format('L')}</span></p>

                <p className='form-confirmation-entry'><strong>Nacionalidad:</strong> <span>{getNationalityName(dropDownOptions?.data?.countries, formik.values.cliente?.nacionalidad)}</span></p>

            </div>

            <div className='form-confirmation-block'>

                <h3 className="multiple-input-heading">Datos de contacto</h3>

                <p className='form-confirmation-entry'><strong>Correo Electrónico:</strong> <span>{formik?.values?.cliente?.mail}</span></p>

                <p className='form-confirmation-entry'>
                    <strong>Teléfono:</strong> <span>{formik?.values?.direccion?.telefono1?.codigoArea + '-' + formik?.values?.direccion?.telefono1?.numero}</span>
                </p>

                {formik?.values?.direccion.pais === '0' &&
                <p className='form-confirmation-entry'>
                    <strong>Dirección:</strong>
                    <span className='form-confirmation-entry-multiline'>
                        <em>País:</em> {getLocalityName(dropDownOptions?.data?.countries, formik?.values?.direccion?.pais)}<br/>
                        <em>Estado:</em> {getLocalityName(dropDownOptions?.data?.states, formik?.values?.direccion?.entidad)}<br/>
                        <em>Ciudad:</em> {getLocalityName(dropDownOptions?.data?.cities, formik?.values?.direccion?.ciudad)}<br/>
                        <em>Municipio:</em> {getLocalityName(dropDownOptions?.data?.municipalities, formik?.values?.direccion?.municipio)}<br/>
                        <em>Parroquia:</em> {getLocalityName(dropDownOptions?.data?.parishies, formik?.values?.direccion?.parroquia)}<br/>
                        <em>Sector:</em> {getLocalityName(dropDownOptions?.data?.sectors, formik?.values?.direccion?.urbanizacion)}<br/>
                        <em>Calle:</em> {formik?.values?.direccion?.calle}<br/>
                        <em>Tipo Inm.:</em> {dropDownOptions?.data?.propertyTypes?.find(item => item?.value === formik?.values?.direccion?.tipoInmueble)?.name}<br/>
                        <em>Nombre Inm.:</em> {formik?.values?.direccion?.nombreInmueble}<br/>
                    </span>
                </p>}

                {formik?.values?.direccion.pais !== '0' &&
                <p className='form-confirmation-entry'>
                    <strong>Dirección:</strong> <span>PAÍS: {getLocalityName(dropDownOptions?.data?.countries, formik?.values?.direccion?.pais)}, {formik?.values?.direccion?.descDireccion}</span>
                </p>}

            </div>

            <div className='form-confirmation-block'>

                <h3 className="multiple-input-heading">Relación</h3>

                <p className='form-confirmation-entry'><strong>Estado Civil:</strong> <span>{CIVIL_STATUS[formik?.values?.cliente?.estadoCivil]}</span></p>

                {((formik.values.cliente?.estadoCivil === 'C' || formik.values.cliente?.estadoCivil === 'U')) &&
                <>
                    <p className='form-confirmation-entry'>
                        <strong>Documento de Identidad del Cónyuge:</strong> <span>{formik?.values?.conyuge?.tipoDocumento !== 'P' ? formik?.values?.conyuge?.tipoDocumento + formik?.values?.conyuge?.cedulaRif : formik?.values?.conyuge?.tipoDocumento + formik?.values?.conyuge?.pasaporte}</span>
                    </p>

                    <p className='form-confirmation-entry'><strong>Nombre completo Cónyuge:</strong> <span>{formik?.values?.conyuge?.nombre + ' ' + formik?.values?.conyuge?.primerApellido + ' ' + formik?.values?.conyuge?.segundoApellido}</span></p>
                </>}

            </div>

            <div className='form-confirmation-block'>

                <h3 className="multiple-input-heading">Recaudos</h3>

                {Object.entries(formik?.values?.recaudos)?.map(([key,value]) => {
                    if (value?.name) {
                        return (
                            <p key={key} className='form-confirmation-entry'>
                                <strong>{key?.replace('constancia','')?.replace(/([A-Z])/g, ' $1')?.trim()}:</strong> <span>{value?.name}</span>
                            </p>
                        );
                    }
                })}

            </div>
            
        </div>

        <div className='form-actions'>

            <Button
                action={() => dispatch(setFormStep(formStep - 1))}
                label={'Regresa'}
                secondaryStyle={true}
                disabled={checkWorkHoursIsLoading}
            />

            <Button
                type="button"
                action={() => handleCheckIfTimeIsWithinWorkHours()}
                // action={formik.handleSubmit}
                label={'Continua'}
                isLoading={checkWorkHoursIsLoading}
            />

        </div>
    </>
  )
}
